import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import levelModal from "models/level.modal";
import Tutorsmodel from "../../../models/tutors.modal";
import { toast } from "lib/helper";
import EnquiryModal from "models/enquiries.modal";
import classlinkingModal from "models/classlinking.modal";

const AddProfile = ({ dataList, toggle, getTutorsProfileData }) => {
  const navigatee = useNavigate();
  const params = useParams();

  const [enqdata, setEnqdata] = useState();
  const getenqury = () => {
    EnquiryModal.getdetails(params?.mid)
      .then((responce) => {
        setEnqdata(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  console.log("responce enq", enqdata);
  useEffect(() => {
    getenqury();
  }, []);
  const [uniqueSubjectIds, setUniqueSubjectIds] = useState([]);
  const [level, setLevel] = useState();

  const GetLevel = async () => {
    classlinkingModal
      .GetbySubject(uniqueSubjectIds)
      .then((responce) => {
        setLevel(responce?.data?.data[0]);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  console.log("get level", level);
  useEffect(() => {
    GetLevel();
  }, [uniqueSubjectIds]);
  useEffect(() => {
    if (enqdata?.[0]?.allSubjects) {
      const subjectIds = enqdata[0].allSubjects?.[0]
        .map((subject) => subject?.id)
        .filter((id, index, self) => self.indexOf(id) === self.lastIndexOf(id));

      setUniqueSubjectIds(subjectIds);
    }
  }, [enqdata]);

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };
  const handleCheckboxvehcle = () => {
    setIsvehcial((prev) => !prev);
  };
  const [inputsPro, setInputsPro] = useState([{ id: 1, value: "" }]);

  const handleInputChangePro = (index, event) => {
    const values = [...inputsPro];
    values[index].value = event.target.value;
    setInputsPro(values);
  };

  const handleAddInputPro = () => {
    const newInputs = [...inputsPro, { id: inputsPro.length + 1, value: "" }];
    setInputsPro(newInputs);
  };

  const handleRemoveInputPro = (index) => {
    if (inputsPro.length === 1) return; // Prevent deletion if only one input field is present
    const values = [...inputsPro];
    values.splice(index, 1);
    setInputsPro(values);
  };
  const [inputsTech, setInputsTech] = useState([{ id: 1, value: "" }]);

  const handleInputChangeTech = (index, event) => {
    const values = [...inputsTech];
    values[index].value = event.target.value;
    setInputsTech(values);
  };
  const inputsTechvalues = inputsTech && inputsTech?.map((item) => item.value);
  const handleAddInputTech = () => {
    const newInputs = [...inputsTech, { id: inputsTech.length + 1, value: "" }];
    setInputsTech(newInputs);
  };

  const handleRemoveInputTech = (index) => {
    if (inputsTech.length === 1) return; // Prevent deletion if only one input field is present
    const values = [...inputsTech];
    values.splice(index, 1);
    setInputsTech(values);
  };

  const [inputsBoards, setInputsBoards] = useState([{ id: 1, value: "" }]);

  const handleInputChangeBoords = (index, event) => {
    const values = [...inputsBoards];
    values[index].value = event.target.value;
    setInputsBoards(values);
  };

  const handleAddInputBoords = () => {
    const newInputs = [
      ...inputsBoards,
      { id: inputsBoards.length + 1, value: "" },
    ];
    setInputsBoards(newInputs);
  };

  const handleRemoveInputBoords = (index) => {
    if (inputsBoards.length === 1) return; // Prevent deletion if only one input field is present
    const values = [...inputsBoards];
    values.splice(index, 1);
    setInputsBoards(values);
  };

  const [inputsGrade, setInputsGrade] = useState([{ id: 1, value: "" }]);

  const handleInputChangeGrade = (index, event) => {
    const values = [...inputsGrade];
    values[index].value = event.target.value;
    setInputsGrade(values);
  };

  // Add new grade input field
  const handleAddInputGrades = () => {
    const newInputs = [
      ...inputsGrade,
      { id: inputsGrade.length + 1, value: "" },
    ];
    setInputsGrade(newInputs);
  };

  // Remove grade input field
  const handleRemoveInputGrade = (index) => {
    if (inputsGrade.length === 1) return; // Prevent deletion if only one input field is there
    const values = [...inputsGrade];
    values.splice(index, 1);
    setInputsGrade(values);
  };

  const [inputsEducation, setInputsEducation] = useState([
    { id: 1, value: "" },
  ]);
  // Handle change in education input fields
  const handleInputChangeEducation = (index, value) => {
    const values = [...inputsEducation];
    values[index] = { ...values[index], value }; // Update the value at the specified index
    setInputsEducation(values);
  };

  // Add new education input field
  const handleAddInputEducation = () => {
    const newInputs = [
      ...inputsEducation,
      { id: inputsEducation.length + 1, value: "" },
    ];
    setInputsEducation(newInputs);
  };

  // Remove education input field
  const handleRemoveInputEducation = (index) => {
    if (inputsEducation.length === 1) return; // Prevent deletion if only one input field is there
    const values = [...inputsEducation];
    values.splice(index, 1);
    setInputsEducation(values);
  };

  const [formData, setFormData] = useState({
    verified: "",
    stars: "",
    description: "",
    Year_Of_Exprinace: "",
    student_throught: "",
    about: "",
    status: "",
    vehicle: "",
    english_fluency: "",
  });

  // input valu change in formdata
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Store the value in the state
    }));
  };

  const handleInputChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked, // Store the checked state of the checkbox in the state
    }));
  };

  const [selectLevel, setSelectdLevel] = useState("");
  const handleSelectStatus = (id) => {
    setSelectdLevel(id);
  };

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      tutor: parseInt(params.mid),
      verified: isChecked,
      stars: parseInt(formData.stars),
      description: formData.description,
      teaching_experience: [
        formData.Year_Of_Exprinace,
        formData.student_throught,
      ],

      about: formData.about,
      teaches: inputsTechvalues,

      vehicle: formData.vehicle,
      english_fluency: formData.english_fluency,
      level: parseInt(selectLevel),
    };
    tutorsModal
      .createTutorsProfile(data)
      .then((response) => {
        getTutorsProfileData();
        toggle();
        helper.sweetalert.toast(response.message, "success");

        // Display success message to the user
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  // const [modal, setModal] = useState(false);
  // const toggle = () => setModal(!modal);

  const [profile, setProfile] = useState("");
  const [ddetail, setDdetail] = useState("");

  const getTutorsProfileData1 = async () => {
    try {
      const result = await tutorsModal.tutordetail(params.id, params.mid);
      if (result) {
        setProfile(result?.data);

        // Set inputsPro based on professional_experience
        const professionalExperience =
          result?.data?.professional_experience || [];
        setInputsPro(
          professionalExperience.length
            ? professionalExperience.map((exp, index) => ({
                id: index + 1,
                value: exp,
              }))
            : [{ id: 1, value: "" }]
        );

        // Set inputsTech based on teaches
        const teaches = result?.data?.teaches || [];
        setInputsTech(
          teaches.length
            ? teaches.map((teach, index) => ({ id: index + 1, value: teach }))
            : [{ id: 1, value: "" }]
        );
        const boards = result?.data?.boards || [];
        setInputsBoards(
          boards.length
            ? boards.map((board, index) => ({ id: index + 1, value: board }))
            : [{ id: 1, value: "" }]
        );
        const grades = result?.data?.grade || [];
        setInputsGrade(
          grades.length
            ? grades.map((grade, index) => ({ id: index + 1, value: grade }))
            : [{ id: 1, value: "" }]
        );
        const education = result?.data?.education || [];
        setInputsEducation(
          education.length
            ? education.map((edu, index) => ({ id: index + 1, value: edu }))
            : [{ id: 1, value: "" }]
        );
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getTutorsProfileData2 = async () => {
    await tutorsModal.listbyTutorsid(params?.id).then((responce) => {
      setDdetail(responce);
      console.log("ffffffty", responce);
    });
  };
  useEffect(() => {
    getTutorsProfileData1();
    getTutorsProfileData2();
  }, []);

  const [ListLevel, setListLevel] = useState([]);
  const getListDataLevel = async () => {
    await levelModal
      .list()
      .then((result) => {
        if (result) {
          setListLevel(result?.data);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getListDataLevel();
    detail();
  }, []);

  const addtutor = async (e) => {
    e.preventDefault();

    const form = new FormData(e.target);
    if(level?.id) {
      form.append("level_link_id",level?.id);
    }
    
    form.append("tutor_id", params?.id);
    form.append("enquiry_id", params?.mid);
    Tutorsmodel.addtutor(form)
      .then((responce) => {
        toast("update profile", "success");
        navigatee(`/admin/linktutorsenquiries/${params?.mid}/${params?.md}`);
      })
      .catch((error) => {
        console.log("error", error);
       
      });
  };
  // Get data
  const detail = async () => {};
  const [age1, setAge1] = useState(null);

  //useEffect(() => {
  // if (profile.dob) {
  //  const calculateAge = (dobString) => {
  //   const birthDate = new Date(dobString);
  //  const today = new Date();
  // let age = today.getFullYear() - birthDate.getFullYear();
  // const monthDifference = today.getMonth() - birthDate.getMonth();

  // Adjust if the birthday hasn't occurred this year yet
  //  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
  //   age--;
  // }

  //  return age;
  // };

  // setAge1(calculateAge(profile.dob));
  // }
  // }, [profile.dob]);

  const [isChecked, setIsChecked] = useState(profile?.verified || false);

  useEffect(() => {
    setIsChecked(profile?.verified || false);
  }, [profile?.verified]);
  const [isvehcial, setIsvehcial] = useState(profile?.vehicle || false);
  useEffect(() => {
    setIsvehcial(profile?.vehicle || false);
  }, [profile?.vehicle]);

  return (
    <div>
      <Container className={`p-2`}>
        <Card
          style={{
            width: "100%",
          }}
          className="mt-7"
        >
          <CardHeader className="p-2 ml-3">
            <h3 className="mb-0" style={{ color: "black" }}>
              Add Profile
            </h3>
          </CardHeader>
          <CardBody
            style={{
              height: "70vh",
              overflowY: "scroll",
            }}
          >
            <Form onSubmit={addtutor}>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label for="exampleEmail">Name</Label>
                    <Input
                      style={{
                        border: "1px solid lightgrey",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                      id="name"
                      placeholder="Name"
                      name="name"
                      value={`${ddetail?.data?.data?.user?.first_name}${" "}${
                        ddetail?.data?.data?.user?.last_name
                      }`}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="exampleEmail">Age</Label>
                    <Input
                      style={{
                        border: "1px solid lightgrey",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                      id="name"
                      name="age"
                      placeholder="Enter Age"
                      defaultValue={profile?.age}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <Label check for="exampleEmail" className="mb-0">
                    Status
                  </Label>
                  <FormGroup check className="mb-0 mr-2">
                    <Input
                      style={{
                        border: "1px solid lightgrey",

                        height: "30px",
                        width: "25px",
                        borderRadius: "6px",
                        marginTop: "10px",
                      }}
                      type="checkbox"
                      id="name"
                      name="verified"
                      placeholder="Mode of Tuition"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                  </FormGroup>
                  <p className="ml-6 mb-0 mt-3">
                    {isChecked ? (
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        Verified
                      </span>
                    ) : (
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        Unverified
                      </span>
                    )}
                  </p>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <p
                    style={{
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "lightgray",
                    }}
                  >
                    Teaching Exprinace
                  </p>{" "}
                </Col>
              </Row>
              <Row>
                {/* <Row> */}
                <Col md={6}>
                  <FormGroup>
                    <Label>Year Of Exprinace</Label>
                    <Input
                      style={{
                        border: "1px solid lightgrey",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                      defaultValue={profile?.teaching_experience}
                      name="teaching_experience[]"
                      placeholder=" Enter Teaching Exprinace"
                      // defaultValue={`${dataList?.state || "-"}/${dataList?.city || '-'}`}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Student Taught</Label>
                    <Input
                      style={{
                        border: "1px solid lightgrey",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                      id="name"
                      defaultValue={profile?.student_thaught}
                      placeholder=" Enter Student"
                      name="student_thaught"
                      // defaultValue={`${dataList?.state || "-"}/${dataList?.city || '-'}`}
                    />
                  </FormGroup>
                </Col>
              </Row>
            
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Class</Label>
                    <Input
                      id="forType"
                     name="teach_class"
                      type="text"
                      value={enqdata?.[0]?.allSubjects?.[0]?.[0]?.name}
                    ></Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Subject</Label>
                    <Input
                      id="forType"
                      type="text"
                      name="subject"
                      value={
                        enqdata?.[0]?.allSubjects?.[0]
                          ?.map((subject) => subject?.name)
                          ?.filter(
                            (name, index, self) =>
                              self.indexOf(name) === self.lastIndexOf(name)
                          ) // Filter out repeated names
                          ?.join(" , ") || "No subjects available" // Join names with ' | '
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="px-4">
              <Col lg={3} md={6} sm={12} className="mb-3">
                  <FormGroup>
                    <div className="d-flex  flex-column space-y-2">
                      <Label className="flex gap-1">
                        <Input
                          type="radio"
                          name="level_link_name"
                          value="level_1"
                          className=""
                        />
                        <span>Level 1</span>
                      </Label>
                      <div className="d-flex">
                        <span className="text-muted mr-1 fs-6">
                          Start - {level?.level_1?.start_price}
                        </span>
                        <span className="text-muted fs-6 ">
                          End - {level?.level_1?.end_price}
                        </span>
                      </div>
                    </div>
                  </FormGroup>
                </Col>
                <Col lg={3} md={6} sm={12} className="mb-3">
                  <FormGroup>
                    <div className="d-flex  flex-column space-y-2">
                      <Label className="flex gap-1">
                        <Input
                          type="radio"
                          name="level_link_name"
                          value="level_2"
                          className=""
                        />
                        <span>Level 2</span>
                      </Label>
                      <div className="d-flex">
                        <span className="text-muted mr-1 fs-5">
                          Start - {level?.level_2?.start_price}
                        </span>
                        <span className="text-muted fs-5 ">
                          End - {level?.level_2?.end_price}
                        </span>
                      </div>
                    </div>
                  </FormGroup>
                </Col>
                <Col lg={3} md={6} sm={12} className="mb-3">
                  <FormGroup>
                    <div className="d-flex  flex-column space-y-2">
                      <Label className="flex gap-1">
                        <Input
                          type="radio"
                          name="level_link_name"
                          value="level_3"
                          className=""
                        />
                        <span>Level 3</span>
                      </Label>
                      <div className="d-flex">
                        <span className="text-muted mr-1 fs-6">
                          Start - {level?.level_3?.start_price}
                        </span>
                        <span className="text-muted fs-6 ">
                          End - {level?.level_3?.end_price}
                        </span>
                      </div>
                    </div>
                  </FormGroup>
                </Col>
                <Col lg={3} md={6} sm={12} className="mb-3">
                  <FormGroup>
                    <div className="d-flex  flex-column space-y-2">
                      <Label className="flex gap-1">
                        <Input
                          type="radio"
                           name="level_link_name"
                          value="level_4"
                          className=""
                        />
                        <span>Level 4</span>
                      </Label>
                      <div className="d-flex">
                        <span className="text-muted mr-1 fs-6">
                          Start - {level?.level_4?.start_price}
                        </span>
                        <span className="text-muted fs-6 ">
                          End - {level?.level_4?.end_price}
                        </span>
                      </div>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="exampleEmail">Description</Label>
                    <Input
                      style={{
                        border: "1px solid lightgrey",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                      id="name"
                      type="textarea"
                      placeholder="Enter Description"
                      defaultValue={profile?.description}
                      onChange={handleInputChange}
                      name="description"
                      // defaultValue={dataList?.mobile}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {/* </Row> */}
              <Row>
                <Col md={12}>
                  <Label>Professional Experience</Label>
                  {inputsPro.map((input, index) => (
                    <div key={input.id}>
                      <Input
                        type="textarea"
                        placeholder="Enter Professional Experience"
                        value={input.value}
                        onChange={(event) => handleInputChangePro(index, event)}
                        className="mt-2"
                        name="professional_experience[]"
                      />
                      {index !== 0 && (
                        <i
                          className="fa-solid fa-xmark"
                          onClick={() => handleRemoveInputPro(index)}
                          style={{
                            float: "right",
                            fontSize: "20px",
                            color: "red",
                            marginBottom: "20px",
                          }}
                        />
                      )}
                    </div>
                  ))}
                  <Row>
                    <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                      <i
                        className="fa-solid fa-plus"
                        onClick={handleAddInputPro}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />

              <Row>
                <Col md={12}>
                  <Label>Teaches </Label>
                  {inputsTech.map((input, index) => (
                    <div key={input.id}>
                      <Input
                        type="textarea"
                        placeholder="Enter Professional Experience"
                        value={input.value}
                        onChange={(event) =>
                          handleInputChangeTech(index, event)
                        }
                        className="mt-2"
                        name="teaches[]"
                      />
                      {index !== 0 && ( // Don't show delete button for first input field
                        <i
                          className="fa-solid fa-xmark"
                          color="danger"
                          onClick={() => handleRemoveInputTech(index)}
                          style={{
                            float: "right",
                            fontSize: "20px",
                            color: "red",
                            marginBottom: "20px",
                          }}
                        />
                      )}
                    </div>
                  ))}
                  <Row>
                    <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                      <i
                        className="fa-solid fa-plus"
                        onClick={handleAddInputTech}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      ></i>{" "}
                      {/* Plus icon to add rows */}
                    </Col>
                  </Row>
                </Col>
              </Row>

              <hr />

              <Row>
                <Col md={12}>
                  <Label for="exampleEmail">Boards </Label>
                  {inputsBoards.map((input, index) => (
                    <div key={input.id}>
                      <Input
                        name="boards[]"
                        type="textarea"
                        placeholder="Enter Boards"
                        value={input.value}
                        onChange={(event) =>
                          handleInputChangeBoords(index, event)
                        }
                        className="mt-2"
                      />
                      {index !== 0 && ( // Don't show delete button for first input field
                        <i
                          className="fa-solid fa-xmark"
                          color="danger"
                          onClick={() => handleRemoveInputBoords(index)}
                          style={{
                            float: "right",
                            fontSize: "20px",
                            color: "red",
                            marginBottom: "20px",
                          }}
                        />
                      )}
                    </div>
                  ))}
                  <Row>
                    <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                      <i
                        className="fa-solid fa-plus"
                        onClick={handleAddInputBoords}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      ></i>{" "}
                      {/* Plus icon to add rows */}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col md={12}>
                  <Label>Grade </Label>
                  {inputsGrade.map((input, index) => (
                    <div key={input.id}>
                      <Input
                        name="grade[]"
                        type="textarea"
                        placeholder="Enter Grade"
                        value={input.value}
                        onChange={(event) =>
                          handleInputChangeGrade(index, event)
                        }
                        className="mt-2"
                      />
                      {index !== 0 && ( // Don't show delete button for first input field
                        <i
                          className="fa-solid fa-xmark"
                          color="danger"
                          onClick={() => handleRemoveInputGrade(index)}
                          style={{
                            float: "right",
                            fontSize: "20px",
                            color: "red",
                            marginBottom: "20px",
                          }}
                        />
                      )}
                    </div>
                  ))}
                  <Row>
                    <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                      <i
                        className="fa-solid fa-plus"
                        onClick={handleAddInputGrades}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      ></i>{" "}
                      {/* Plus icon to add rows */}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col md={12}>
                  <Label for="exampleEmail">Education </Label>
                  {inputsEducation.map((input, index) => (
                    <div key={input.id}>
                      <Input
                        name="education[]"
                        type="textarea"
                        placeholder="Enter Education"
                        value={input.value}
                        onChange={(event) =>
                          handleInputChangeEducation(index, event.target.value)
                        }
                        className="mt-2"
                      />
                      {index !== 0 && ( // Don't show delete button for first input field
                        <i
                          className="fa-solid fa-xmark"
                          color="danger"
                          onClick={() => handleRemoveInputEducation(index)}
                          style={{
                            float: "right",
                            fontSize: "20px",
                            color: "red",
                            marginBottom: "20px",
                          }}
                        />
                      )}
                    </div>
                  ))}
                  <Row>
                    <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                      <i
                        className="fa-solid fa-plus"
                        onClick={handleAddInputEducation}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      ></i>{" "}
                      {/* Plus icon to add rows */}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="exampleEmail">About</Label>
                    <Input
                      style={{
                        border: "1px solid lightgrey",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                      id="name"
                      value={profile?.about}
                      onChange={handleInputChange}
                      placeholder="Enter About"
                      type="textarea"
                      name="about"
                      // defaultValue={dataList.referral || '-'}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Label check className="mb-0">
                    Star
                  </Label>
                  <FormGroup>
                    <Input
                      style={{
                        border: "1px solid lightgrey",
                        borderRadius: "6px",
                        marginTop: "10px",
                      }}
                      type="number"
                      id="name"
                      name="stars"
                      placeholder="Enter Start"
                      onChange={handleInputChange}
                      max={5}
                      defaultValue={profile?.stars}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={3}>
                  <Label check for="exampleEmail" className="mb-0">
                    Vehicle
                  </Label>
                  <FormGroup check className="mb-0 mr-2">
                    <input
                      style={{
                        height: "25px",
                        width: "25px",

                        marginTop: "10px",
                      }}
                      type="checkbox"
                      id="name"
                      name="vehicle"
                      placeholder="Mode of Tuition"
                      checked={isvehcial}
                      onChange={handleCheckboxvehcle}
                    />
                  </FormGroup>
                </Col>

                <Col md={9}>
                  <Label className="mb-0">English Fluency</Label>
                  <FormGroup className="">
                    <Input
                      type="text"
                      id="name"
                      name="english_fluency"
                      placeholder="Enter Englist Fluency"
                      defaultValue={profile?.english_fluency}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row className="mt-1">
                <Col>
                  <Button
                    color="primary"
                    type="submit"
                    style={{ float: "right", marginLeft: "5%" }}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AddProfile;
